import { SITE_LOGO, SITE_URL } from '../config/site';

export interface BreadcrumbEntry { name: string; path: string }
type Node = Record<string, unknown>;
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const AUTHOR_URL = `${SITE_URL}/about#greeting`;

const person = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(person);
  if (!value || typeof value !== 'object') return value;
  const author = value as Node;
  if (author['@type'] === 'Person' && author.name === '立山勲矢') {
    return { ...author, url: AUTHOR_URL };
  }
  if (author['@type'] === 'Organization' && author.name === '株式会社BanSow') {
    return { ...author, '@id': ORGANIZATION_ID, url: SITE_URL };
  }
  return author;
};

// CollectionPage lists contain nested articles; preserve their author references too.
function normalizeReferences(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(normalizeReferences);
  if (!value || typeof value !== 'object') return value;
  const result: Node = {};
  for (const [key, child] of Object.entries(value)) {
    result[key] = key === 'author' || key === 'publisher'
      ? person(normalizeReferences(child)) : normalizeReferences(child);
  }
  return result;
}

export function resolveStructuredData(
  schema: Node | undefined, pathname: string, breadcrumbs: BreadcrumbEntry[] = [],
): Node | undefined {
  const nodes: Node[] = schema
    ? (Array.isArray(schema['@graph']) ? schema['@graph'] as Node[] : [schema])
      .map((original) => {
        const node = normalizeReferences(original) as Node;
        delete node['@context'];
        if (node.author) node.author = person(node.author);
        if (node.publisher) node.publisher = person(node.publisher);
        if (node['@type'] === 'Organization' && node.name === '株式会社BanSow') {
          node['@id'] = ORGANIZATION_ID;
        }
        return node;
      }) : [];
  if (pathname === '/') {
    nodes.push({
      '@type': 'WebSite', '@id': `${SITE_URL}/#website`, name: 'BanSow',
      alternateName: ['バンソウ', '株式会社BanSow'], url: `${SITE_URL}/`,
      inLanguage: 'ja', publisher: { '@id': ORGANIZATION_ID },
    });
  }
  if (breadcrumbs.length > 1) {
    nodes.push({
      '@type': 'BreadcrumbList', '@id': `${SITE_URL}${pathname}#breadcrumb`,
      itemListElement: breadcrumbs.map((entry, index) => ({
        '@type': 'ListItem', position: index + 1, name: entry.name,
        item: new URL(entry.path, SITE_URL).href,
      })),
    });
  }
  return nodes.length ? { '@context': 'https://schema.org', '@graph': nodes } : undefined;
}

export const guidePublisher = {
  '@type': 'Organization', '@id': ORGANIZATION_ID, name: '株式会社BanSow',
  url: SITE_URL, logo: { '@type': 'ImageObject', url: SITE_LOGO },
};
